import EditStudentDetailLayout from '../components/organisms/EditStudentDetailLayout';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import useEditStudents from '../hooks/editStudents.hook';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditStudentDetail = () => {
  const {
    studentDetail,
    loaderOpen,
    handleFormUpdate,
    handleFormSubmission,
    submissionLoader,
    handleDateFormatting,
    handleDocDeletion,
    handleFileUpload,
    clearDate,
  } = useEditStudents();

  return (
    <div>
      <ToastContainer />

      <EditStudentDetailLayout
        studentDetail={studentDetail}
        handleFormUpdate={handleFormUpdate}
        handleDateFormatting={handleDateFormatting}
        handleFormSubmission={handleFormSubmission}
        loading={submissionLoader}
        handleDocDeletion={handleDocDeletion}
        handleFileUpload={handleFileUpload}
        clearDate={clearDate}
      />
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={loaderOpen}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </div>
  );
};

export default EditStudentDetail;
